const BASIC_COST = 25;
const BASIC_COST_RATE = 2;
export const getUpgradeCost = (level: number, grade: string) => {
  return (
    BASIC_COST * BASIC_COST_RATE ** (level - 1 + getBasicLevelByGrade(grade))
  );
};

const BASIC_COUNT = 2;
export const getUpgradeCount = (level: number) => {
  return BASIC_COUNT ** level;
};
export function getBasicLevelByGrade(grade: string) {
  switch (grade) {
    case "normal":
      return 0;
    case "race":
      return 2;
    case "epic":
      return 5;
    case "legend":
      return 8;
    default:
      return 0;
  }
}

const envMode = import.meta.env.VITE_ENV_MODE;
export const isTest = envMode === "test";
